// Configuration from environment variables or runtime API
interface Config {
  oauth: {
    authorizeUrl: string;
    tokenUrl: string;
    clientId: string;
    redirectUri: string;
  };
  api: {
    baseUrl: string;
  };
  cloudHub: {
    docsBaseUrl: string;
  };
}

let runtimeConfig: Config | null = null;

// Fetch configuration from backend API
export async function loadConfig(): Promise<Config> {
  if (runtimeConfig) {
    return runtimeConfig;
  }

  try {
    const response = await fetch('/api/v1/config');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`);
    }
    const loadedConfig: Config = await response.json();
    runtimeConfig = loadedConfig;
    
    // Update the config object with loaded values
    Object.assign(config.oauth, loadedConfig.oauth);
    Object.assign(config.api, loadedConfig.api);
    Object.assign(config.cloudHub, loadedConfig.cloudHub);
    
    return loadedConfig;
  } catch (error) {
    console.error('Failed to load runtime config:', error);
    // Fallback to environment variables if available
    const fallbackConfig = {
      oauth: {
        authorizeUrl: import.meta.env.VITE_OAUTH_AUTHORIZE_URL || '',
        tokenUrl: import.meta.env.VITE_OAUTH_TOKEN_URL || '',
        clientId: import.meta.env.VITE_OAUTH_CLIENT_ID || '',
        redirectUri: import.meta.env.VITE_OAUTH_REDIRECT_URI || '',
      },
      api: {
        baseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1',
      },
      cloudHub: {
        docsBaseUrl: import.meta.env.VITE_CLOUDHUB_DOCS_BASE_URL || 'https://documentation.pantaris.io',
      },
    };
    runtimeConfig = fallbackConfig;
    Object.assign(config.oauth, fallbackConfig.oauth);
    Object.assign(config.api, fallbackConfig.api);
    Object.assign(config.cloudHub, fallbackConfig.cloudHub);
    return fallbackConfig;
  }
}

// Config object that will be populated after loadConfig() is called
export const config = {
  oauth: {
    authorizeUrl: '',
    tokenUrl: '',
    clientId: '',
    redirectUri: '',
  },
  api: {
    baseUrl: '/api/v1',
  },
  cloudHub: {
    docsBaseUrl: 'https://documentation.pantaris.io',
  },
};
